<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="50"
    height="50"
    viewBox="0 0 172 172"
    style=" fill:#94A3B8;"
  >
    <g
      fill="none"
      fill-rule="nonzero"
      stroke="none"
      stroke-width="1"
      stroke-linecap="butt"
      stroke-linejoin="miter"
      stroke-miterlimit="10"
      stroke-dasharray=""
      stroke-dashoffset="0"
      font-family="none"
      font-weight="none"
      font-size="none"
      text-anchor="none"
      style="mix-blend-mode: normal"
    >
      <path d="M0,172v-172h172v172z" fill="none" stroke="none"></path>
      <g
        id="original-icon"
        fill="#94A3B8"
        stroke="none"
        opacity="0"
        visibility="hidden"
      >
        <path
          d="M24.08,6.88v158.24h123.84v-114.9175l-0.9675,-1.075l-41.28,-41.28l-1.075,-0.9675zM30.96,13.76h68.8v41.28h41.28v103.2h-110.08zM106.64,18.705l29.455,29.455h-29.455zM48.16,34.4v6.88h44.72v-6.88zM48.16,48.16v6.88h44.72v-6.88zM48.16,61.92v6.88h79.12v-6.88zM48.16,75.68v6.88h79.12v-6.88zM48.16,89.44v6.88h79.12v-6.88zM69.3375,105.135c-3.91031,0 -7.095,2.49938 -9.245,5.6975c-2.15,3.19813 -3.44,7.31 -3.44,11.825c0,3.78938 1.1825,7.90125 3.44,11.395c0.29563,0.45688 0.83313,0.73906 1.1825,1.1825c-1.11531,0.99438 -3.225,3.1175 -3.225,3.1175c-1.10187,0.67188 -1.74687,1.89469 -1.65281,3.18469c0.08063,1.29 0.88688,2.41875 2.08281,2.92938c1.1825,0.51062 2.55313,0.30906 3.5475,-0.52406c0,0 2.88906,-2.80844 4.945,-4.6225c1.26313,0.49719 2.40531,1.29 3.87,1.29c8.68063,0 14.43188,-4.67625 17.7375,-8.9225c0.9675,-1.24969 1.49156,-2.15 2.15,-3.225c0.24188,0.73906 0.45688,1.43781 0.7525,2.15c0.215,0.51063 0.45688,1.02125 0.86,1.6125c0.40313,0.59125 1.16906,1.935 3.3325,1.935c2.29781,0 3.70875,-1.10187 5.0525,-2.0425c1.34375,-0.94062 2.55313,-1.98875 3.87,-3.01c2.63375,-2.05594 5.28094,-3.655 7.2025,-3.655c1.23625,0.01344 2.39188,-0.63156 3.02344,-1.70656c0.61813,-1.075 0.61813,-2.39187 0,-3.46687c-0.63156,-1.075 -1.78719,-1.72 -3.02344,-1.70656c-4.8375,0 -8.50594,2.795 -11.395,5.0525c-1.23625,0.9675 -2.23062,1.81406 -3.1175,2.4725c-0.1075,-0.3225 -0.20156,-0.51062 -0.3225,-0.86c-0.37625,-1.10187 -0.84656,-2.21719 -1.3975,-3.3325c-0.28219,-0.56437 -0.52406,-1.20937 -1.075,-1.8275c-0.55094,-0.61812 -1.59906,-1.505 -3.225,-1.505c-2.23062,0 -2.99656,1.35719 -3.5475,2.0425c-0.55094,0.68531 -0.9675,1.30344 -1.3975,2.0425c-0.87344,1.46469 -1.84094,3.19813 -3.1175,4.8375c-2.31125,2.96969 -5.61687,5.41531 -10.8575,5.9125c3.53406,-4.75687 6.665,-10.68281 6.665,-17.845c0,-2.32469 -0.43,-4.86437 -2.0425,-6.9875c-1.6125,-2.12312 -4.47469,-3.44 -7.6325,-3.44zM69.3375,112.015c1.505,0 1.78719,0.28219 2.15,0.7525c0.36281,0.47031 0.645,1.49156 0.645,2.795c0,5.4825 -2.98312,10.62906 -6.235,14.7275c-1.43781,-2.23062 -2.365,-5.36156 -2.365,-7.6325c0,-3.15781 0.95406,-6.11406 2.2575,-8.0625c1.30344,-1.94844 2.795,-2.58 3.5475,-2.58z"
        ></path>
      </g>
      <g id="subtracted-icon" fill="#94A3B8" stroke="none">
        <path
          d="M104.5975,6.88l1.075,0.9675l41.28,41.28l0.9675,1.075l0,47.432c-2.22747,-0.57874 -4.52651,-0.97492 -6.88,-1.17143v-41.42307h-41.28v-41.28h-68.8v144.48l70.92751,0c1.4339,2.46475 3.11553,4.76967 5.01013,6.88h-82.81764v-158.24zM106.64,48.16h29.455l-29.455,-29.455zM92.88,34.4v6.88h-44.72v-6.88zM92.88,48.16v6.88h-44.72v-6.88zM127.28,61.92v6.88h-79.12v-6.88zM127.28,75.68v6.88h-79.12v-6.88zM127.28,89.44v6.88h-79.12v-6.88zM76.97,108.575c1.6125,2.12313 2.0425,4.66281 2.0425,6.9875c0,7.16219 -3.13094,13.08813 -6.665,17.845c5.24063,-0.49719 8.54625,-2.94281 10.8575,-5.9125c1.27656,-1.63937 2.24406,-3.37281 3.1175,-4.8375c0.43,-0.73906 0.84656,-1.35719 1.3975,-2.0425c0.55094,-0.68531 1.31688,-2.0425 3.5475,-2.0425c1.62594,0 2.67406,0.88688 3.225,1.505c0.55094,0.61813 0.79281,1.26313 1.075,1.8275c0.55094,1.11531 1.02125,2.23063 1.3975,3.3325c0.12094,0.34938 0.215,0.5375 0.3225,0.86c0.28054,-0.20828 0.57183,-0.43538 0.87814,-0.67918c-0.8669,2.7864 -1.44495,5.69691 -1.69874,8.69607c-0.25209,0.02967 -0.51558,0.0456 -0.7919,0.0456c-2.16344,0 -2.92937,-1.34375 -3.3325,-1.935c-0.40312,-0.59125 -0.645,-1.10187 -0.86,-1.6125c-0.29562,-0.71219 -0.51062,-1.41094 -0.7525,-2.15c-0.65844,1.075 -1.1825,1.97531 -2.15,3.225c-3.30562,4.24625 -9.05687,8.9225 -17.7375,8.9225c-1.46469,0 -2.60687,-0.79281 -3.87,-1.29c-2.05594,1.81406 -4.945,4.6225 -4.945,4.6225c-0.99437,0.83313 -2.365,1.03469 -3.5475,0.52406c-1.19594,-0.51063 -2.00219,-1.63938 -2.08281,-2.92938c-0.09406,-1.29 0.55094,-2.51281 1.65281,-3.18469c0,0 2.10969,-2.12312 3.225,-3.1175c-0.34937,-0.44344 -0.88687,-0.72562 -1.1825,-1.1825c-2.2575,-3.49375 -3.44,-7.60562 -3.44,-11.395c0,-4.515 1.29,-8.62687 3.44,-11.825c2.15,-3.19812 5.33469,-5.6975 9.245,-5.6975c3.15781,0 6.02,1.31688 7.6325,3.44zM65.79,114.595c-1.30344,1.94844 -2.2575,4.90469 -2.2575,8.0625c0,2.27094 0.92719,5.40188 2.365,7.6325c3.25188,-4.09844 6.235,-9.245 6.235,-14.7275c0,-1.30344 -0.28219,-2.32469 -0.645,-2.795c-0.36281,-0.47031 -0.645,-0.7525 -2.15,-0.7525c-0.7525,0 -2.24406,0.63156 -3.5475,2.58z"
        ></path>
      </g>
      <g stroke="none">
        <g fill="currentColor">
          <g
            id="Слой_2"
            font-family="Inter, sans-serif"
            font-weight="400"
            font-size="16"
            text-anchor="start"
            visibility="hidden"
          ></g>
          <g
            id="Android_x5F_4"
            font-family="Inter, sans-serif"
            font-weight="400"
            font-size="16"
            text-anchor="start"
            visibility="hidden"
          ></g>
          <g
            id="Android_x5F_5"
            font-family="Inter, sans-serif"
            font-weight="400"
            font-size="16"
            text-anchor="start"
            visibility="hidden"
          ></g>
          <g
            id="Windows_x5F_8"
            font-family="Inter, sans-serif"
            font-weight="400"
            font-size="16"
            text-anchor="start"
            visibility="hidden"
          ></g>
          <g
            id="Windows_x5F_10"
            font-family="Inter, sans-serif"
            font-weight="400"
            font-size="16"
            text-anchor="start"
            visibility="hidden"
          ></g>
          <g
            id="Color"
            font-family="Inter, sans-serif"
            font-weight="400"
            font-size="16"
            text-anchor="start"
            visibility="hidden"
          ></g>
          <g
            id="IOS"
            font-family="Inter, sans-serif"
            font-weight="400"
            font-size="16"
            text-anchor="start"
            visibility="hidden"
          ></g>
          <g id="IOS_copy">
            <path
              d="M137.6,172c-18.92,0 -34.4,-15.48 -34.4,-34.4c0,-18.92 15.48,-34.4 34.4,-34.4c18.92,0 34.4,15.48 34.4,34.4c0,18.92 -15.48,34.4 -34.4,34.4zM137.6,110.08c-15.136,0 -27.52,12.384 -27.52,27.52c0,15.136 12.384,27.52 27.52,27.52c15.136,0 27.52,-12.384 27.52,-27.52c0,-15.136 -12.384,-27.52 -27.52,-27.52zM157.552,126.248l-5.16,-4.472l-18.576,21.672l-11.352,-8.6l-4.128,5.504l16.168,12.384z"
            ></path>
          </g>
        </g>
        <g fill="#94A3B8" opacity="0">
          <g
            id="IOS"
            font-family="Inter, sans-serif"
            font-weight="400"
            font-size="16"
            text-anchor="start"
            visibility="hidden"
          ></g>
          <g id="IOS_copy">
            <path
              d="M137.6,178.88c22.704,0 41.28,-18.576 41.28,-41.28c0,-22.704 -18.576,-41.28 -41.28,-41.28c-22.704,0 -41.28,18.576 -41.28,41.28c0,22.704 18.576,41.28 41.28,41.28z"
            ></path>
          </g>
        </g>
      </g>
      <path
        d="M103.2,172v-68.8h68.8v68.8z"
        id="overlay-drag"
        fill="#ff0000"
        stroke="none"
        opacity="0"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>